export const Success = 200;
export const Created = 201;
export const ErrorNotFound = 400;
export const Unauthorized = 401;
export const ServerError = 500;
